import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

type Props = ReturnType<typeof mapStateToProps>;

export function ProfileLink({ name }: Props) {
  return (
    <a
      href={`/profile/${name}`}
      target="_blank"
      className="button button--primary button--no-margin"
      rel="noopener noreferrer"
    >
    View profile
    </a>
  );
}

const mapStateToProps = ({ myself: { character: { name } } }: IAppState) => ({ name });

export default connect(mapStateToProps)(ProfileLink);